/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import cx from "classnames";
import React, { ReactNode, useState } from "react";

import IconDown from "../../../../shared/icons/chevron-down.svg";

import "./DropdownMenuItemExpandable.scss";

interface DropdownMenuItemExpandableProps {
  title?: string;
  onTitleClick?: () => boolean;
  orderInParent?: number;
  onItemSelect?: () => void;
  children: ReactNode;
  active?: boolean;
}

export const DropdownMenuItemExpandable = (
  props: DropdownMenuItemExpandableProps,
) => {
  const { active, orderInParent, title, onTitleClick, onItemSelect, children } =
    props;

  const [isExpanded, setIsExpanded] = useState(false);

  const expand = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded((prevValue) => !prevValue);
  };

  const onTitleSectionClick = (e: React.MouseEvent) => {
    if (onTitleClick) {
      e.preventDefault();
      e.stopPropagation();
      if (!onTitleClick()) {
        setIsExpanded((prevValue) => !prevValue);
      }
    }
  };

  return (
    <div className="DropdownMenuItemExpandable">
      <div
        className={cx("DropdownMenuItemExpandable__Header", {
          ["DropdownMenuItemExpandable__Header--active"]:
            active && !onTitleClick,
        })}
        onClick={expand}
      >
        <div
          className={cx("DropdownMenuItemExpandable__Title", {
            ["DropdownMenuItemExpandable__Title--active"]: active,
          })}
          onClick={onTitleSectionClick}
        >
          <div className="DropdownMenuItemExpandable__OrderInParent">
            {orderInParent}
          </div>
          {title}
        </div>
        <div
          className={cx(
            "DropdownMenuItemExpandable__Icon",
            isExpanded && "arrow-up",
          )}
          onClick={expand}
        >
          <IconDown aria-hidden="true" focusable="false" />
        </div>
      </div>
      {isExpanded && (
        <div
          className="DropdownMenuItemExpandable__Content"
          onClick={onItemSelect}
        >
          {children}
        </div>
      )}
    </div>
  );
};
